const FileHistory = require('./FileHistory')
const Message = require('./Message')
const Payment = require('./Payment')
const queryJob = require('./QueryJob')
const SeaExport = require('./SeaExport')
const WriteOff = require('./WriteOff')
const Invoice = require('./Invoice')
const FinanceManage = require('./FinanceManage')
const Billing = require('./Billing')
const Project = require('./Project')
const Partners = require('./Partners')
const CargoMsg = require('./CargoMsg')
const Menu = require('./Menu')
const Viewer = require('./Viewer')
const Template = require('./Template')
const Order = require('./Order')
const Warehouse = require('./Warehouse')
const Pricing = require('./Pricing')
const SpecialGoods = require('./SpecialGoods')
const RailwayExport = require('./RailwayExport')
const myResources = require('./myResources')
const Tool = require('./Tool')
const Insurance = require('./Insurance')
const Sop = require('./Sop')
const ChangeCharge = require('./ChangeCharge')
const ReleaseNotes = require('./ReleaseNotes')
const BusinessIntelligence = require('./BusinessIntelligence')
const FbaJob = require('./FbaJob')
const FbaChannel = require('./FbaChannel')
const FbaQuotation = require('./FbaQuotation')
const AutomaticRelease = require('./AutomaticRelease')
const AirExport = require('./AirExport')
const AirImport = require('./AirImport')
const Analysis = require('./Analysis')
const BiAnalysis = require('./BiAnalysis')
const Clearing = require('./Clearing')
const Information = require('./Information')
const Integrated = require('./Integrated')
const Price = require('./Price')
const ProjectManage = require('./ProjectManage')
const Sales = require('./Sales')
const SeaImport = require('./SeaImport')
const SystemDocking = require('./SystemDocking')
const SystemMaintenance = require('./SystemMaintenance')
const SystemMonitor = require('./SystemMonitor')
const TenantMaintain = require('./TenantMaintain')
const OperationGuide = require('./OperationGuide')
const AdvancePayment = require('./AdvancePayment')
const PillReport = require('./PillReport')
module.exports = {
  FileHistory,
  Message,
  Payment,
  Tool,
  queryJob,
  SeaExport,
  WriteOff,
  Invoice,
  FinanceManage,
  Billing,
  Project,
  Partners,
  CargoMsg,
  Menu,
  Viewer,
  Template,
  Order,
  Warehouse,
  Pricing,
  SpecialGoods,
  myResources,
  RailwayExport,
  Insurance,
  Sop,
  ChangeCharge,
  ReleaseNotes,
  BusinessIntelligence,
  FbaJob,
  FbaChannel,
  FbaQuotation,
  AutomaticRelease,
  AirExport,
  AirImport,
  Analysis,
  BiAnalysis,
  Clearing,
  Information,
  Integrated,
  Price,
  ProjectManage,
  Sales,
  SeaImport,
  SystemDocking,
  SystemMaintenance,
  SystemMonitor,
  TenantMaintain,
  OperationGuide,
  AdvancePayment,
  PillReport
}
